import { useController } from 'react-hook-form';

export function useFormConnect(name: string) {
  const { field, fieldState } = useController({ name });
  return { ...field, error: fieldState.error?.message };
}
